/**
 * The person's measurements, engine-free: where the joints are on a figure
 * standing on y = 0 facing -Z, metres. The rig (`three/character/rig.ts`)
 * builds its parts to these, the crowd hangs them from these joints, and the
 * ragdoll (`ragdoll.ts`) joins its points by these lengths.
 */

export const BODY = {
  /** Hip joint height above the soles. */
  hip: 0.95,
  /** Hip joints either side of centre. */
  hipWidth: 0.09,
  /** Waist, where the torso pivots, above the hip joint. */
  waist: 0.05,
  torsoHeight: 0.46,
  /** Shoulder joints, from the waist and either side of centre. */
  shoulderHeight: 0.42,
  shoulderWidth: 0.205,
  upperArm: 0.27,
  thigh: 0.45,
  shin: 0.43,
} as const;

/** Where the palm is along the forearm, from the elbow: the hand's middle. */
export const PALM = 0.265;

/** How far the hip joints hang below the hips' pivot. */
export const HIP_DROP = 0.02;

/** The middle of the head, up from the neck's pivot. */
export const HEAD_CENTRE = 0.15;

/** The breastbone, in the torso's frame from the waist: up, and out in front. */
export const CHEST: readonly [number, number, number] = [0, 0.3, -0.1];

/** The front of the pelvis, from the hips' pivot: down a little, and out in front. */
export const BELLY: readonly [number, number, number] = [0, -0.04, -0.12];

/** The toe, in the foot's frame from the ankle: down to the sole's middle, forward to its tip. */
export const TOE: readonly [number, number, number] = [0, -0.04, -0.15];
